import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  permiteNegociacaoParcial: true,
};

export default rules;
